module.exports = __webpack_public_path__ + "09eba60728782f0db38b084908b0bf88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/10_PROP_VET_11-3.png
// module id = 110
// module chunks = 0